/** ***********************************************************************
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import './AppsSkeletonUI.scss';

export const getAppsUISkeleton = () => {
	const appCards = Array.from({length: 8});
	const appSections = Array.from({length: 2});

	const appCardsHtml = appCards
		.map(
			(_, index) =>
				`<div key="${index}" class="sk-wiper-on-layout card-loader"></div>`,
		)
		.join('');

	const appSectionsHtml = appSections
		.map(
			(_, sectionIndex) =>
				`<div key="${sectionIndex}">
					<div class="sk-wiper-on-layout header-view-wrapper"></div>
						<div class="card-view-wrapper">
							<div class="sk-section-cards-wrapper">
								${appCardsHtml}
							</div>
						</div>
				</div>`,
		)
		.join('');

	const appsCatalogSkeleton = `<div class='apps-skeleton'>
		<div class='loaderWrapper'><div class='filterWrapper'>
			<div class='filterContainer'>
				<div class='categories-with-chevron'>
					<div class='buttonGroup'>
						<div class='sk-wiper-on-layout buttonGroupItem'></div>
						<div class='sk-wiper-on-layout buttonGroupItem'></div>
						<div class='sk-wiper-on-layout buttonGroupItem'></div>
						<div class='sk-wiper-on-layout buttonGroupItem'></div>
					</div>
				</div>
				<div class='sk-wiper-on-layout uiFilter-section'></div>
			</div>
		</div>
		${appSectionsHtml}
		</div>
		</div>`;

	if (window.location.pathname.includes('pdp')) {
		const pdpSkeleton = `<div class='apps-skeleton'><div class='outerDivPdp'>
				<div class='pdp-left-panel'>
					<div class='sk-wiper-on-layout pdp-info-card'></div>
				</div>
				<div class='pdp-right-panel'>
					<div class='pdp-right-panel-wrapper'>
						<div class='sk-wiper-on-layout banner1'></div>
						<div class='sk-wiper-on-layout banner2'></div>
						<div class='sk-wiper-on-layout banner3'></div>
					</div>
				</div>
			</div>
		</div>`;

		return pdpSkeleton;
	}
	return appsCatalogSkeleton;
};
